<template>
  <div class="consultant-banner" dir="rtl">
    <div v-if="consultant.logoUrl" class="consultant-banner__logo-wrap">
      <img
        :src="consultant.logoUrl"
        :alt="consultant.name"
        class="consultant-banner__logo"
      />
    </div>
    <div v-else class="consultant-banner__logo-placeholder-wrap">
      <div class="consultant-banner__logo-placeholder">
        {{ consultant.name }}
      </div>
    </div>

    <div class="consultant-banner__text">
      <p
        v-for="(line, i) in textLines"
        :key="i"
        class="consultant-banner__text-para"
      >{{ line }}</p>
    </div>

    <a
      v-if="discountStrip"
      :href="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="consultant-banner__discount"
      @click="onWhatsappClick"
    >{{ discountStrip }}</a>

    <a
      :href="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="consultant-banner__btn"
      @click="onWhatsappClick"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" class="consultant-banner__wa-icon">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
      </svg>
      <span class="consultant-banner__btn-text">דברו איתנו ב-WhatsApp</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ConsultantBanner',
  props: {
    consultant: {
      type: Object,
      required: true,
      validator: (obj) => Boolean(obj && obj.name && obj.text && obj.whatsappNumber),
    },
  },
  computed: {
    textLines() {
      return (this.consultant.text || '').split('\n\n').filter(Boolean);
    },
    discountStrip() {
      if (!this.consultant.discountPercent) return null;
      return `🎁 גולשי האתר מקבלים ${this.consultant.discountPercent}% הנחה!`;
    },
    whatsappUrl() {
      let message = this.consultant.whatsappMessage || '';
      if (this.consultant.discountPercent) {
        message += `\nשימו לב — כגולשי האתר מגיעה לכם ${this.consultant.discountPercent}% הנחה!`;
      }
      return `https://wa.me/${this.consultant.whatsappNumber}?text=${encodeURIComponent(message)}`;
    },
  },
  methods: {
    onWhatsappClick() {
      if (window.fbq) {
        window.fbq('track', 'goToTravelConsultant');
      }
    },
  },
};
</script>

<style scoped>
.consultant-banner {
  background: #E0F7FA;
  border: 2px solid #00BCD4;
  border-radius: 14px;
  padding: 20px 16px;
  margin: 16px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.consultant-banner__logo-wrap,
.consultant-banner__logo-placeholder-wrap {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #00BCD4;
  flex-shrink: 0;
}

.consultant-banner__logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.consultant-banner__logo-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #006994, #00BCD4);
  color: white;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4px;
  line-height: 1.3;
}

.consultant-banner__text {
  font-size: 16px;
  color: #374151;
  width: 100%;
  text-align: center;
}

.consultant-banner .consultant-banner__text-para {
  margin: 0 0 6px;
  line-height: 1.6;
  text-align: center !important;
}

.consultant-banner .consultant-banner__text-para:last-child {
  margin-bottom: 0;
}

.consultant-banner .consultant-banner__text-para:first-child {
  font-weight: bold;
  font-size: 18px;
  color: #004d70;
}

.consultant-banner .consultant-banner__discount {
  width: 100%;
  max-width: 320px;
  background: linear-gradient(135deg, #e65c00, #f9d423);
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 11px 20px;
  border-radius: 10px;
  text-align: center !important;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  box-sizing: border-box;
}

.consultant-banner__btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 320px;
  background: linear-gradient(135deg, #006994, #00BCD4);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  direction: ltr;
}

.consultant-banner__btn-text {
  unicode-bidi: isolate;
  direction: rtl;
}

.consultant-banner__btn:hover {
  opacity: 0.9;
  color: white;
  text-decoration: none;
}

.consultant-banner__wa-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
</style>
